import { render, staticRenderFns } from "./SwitchHandler.vue?vue&type=template&id=4393c80b"
import script from "./SwitchHandler.vue?vue&type=script&lang=ts"
export * from "./SwitchHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports